<template>
  <section
    class="advent-calendar-section"
    :style="{
      background: `url('${adventCalendarAttrs.feast_background}'), ${$root.color_schema.secondary}`,
    }"
    v-if="Object.keys(adventCalendarData.data).length > 0"
  >
    <div class="container">
      <div class="row">
        <!--Breadcrumps-->
        <div class="col-md-12" v-if="activeBreadcrumb">
          <Breadcrumb
            :breadcrumbData="adventCalendarBreadcrumbs"
            :dark="false"
          />
        </div>
        <!--End Breadcrumps-->
        <div
          class="advent-header"
          v-if="
            adventCalendarAttrs && Object.keys(adventCalendarAttrs).length > 0
          "
        >
          <span
            :class="{
              'span-h1': true,
              'text-white': !getContrastYIQ($root.color_schema.primary),
              'text-gray': getContrastYIQ($root.color_schema.primary),
            }"
            v-if="adventCalendarAttrs.feast_heading"
            >{{ adventCalendarAttrs.feast_heading }}</span
          >
          <p class="custom-font-2" v-if="adventCalendarAttrs.feast_sub_heading">
            {{ adventCalendarAttrs.feast_sub_heading }}
          </p>
        </div>
        <div class="advent-cards-wrapper-outer">
          <div
            :class="{
              'advent-card advent-card-yellow': true,
              'advent-card-big':
                getTimeStamp(data.Ymd, 'addate') === getTimeStamp('', 'today'),
              'advent-card-mobile':
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today'),
              'advent-promo-card':
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today') &&
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today', 2),
              'not-active':
                !getTimeStamp(data.Ymd, 'addate') <= getTimeStamp('', 'today'),
            }"
            v-for="(data, index) in currentData"
            :key="index"
          >
            <template
              v-if="
                data.type === 'partner' &&
                Object.keys(data.partner_information).length > 0
              "
            >
              <div
                :class="{
                  'advent-card-bg': true,
                  'advent-promo-card-up-bg': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <template
                  v-if="
                    !(
                      getTimeStamp(data.Ymd, 'addate') <=
                      getTimeStamp('', 'today')
                    )
                  "
                >
                  <img
                    v-if="adventCalendarAttrs.card_coming_soon_image"
                    :src="adventCalendarAttrs.card_coming_soon_image"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
                <template v-else>
                  <img
                    v-if="adventCalendarAttrs.feast_card_background"
                    :src="adventCalendarAttrs.feast_card_background"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
              </div>
              <div
                :class="{
                  'advent-card-content': true,
                  'advent-promo-card': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  class="cas-logo partner-logo pt-100 cas-link"
                >
                  <img
                    v-if="
                      assetsSize &&
                      assetsSize.pro_asset_sizes &&
                      data.partner_information.product_assets &&
                      data.partner_information.product_assets.length > 0
                    "
                    :src="
                      data.partner_information.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assetsSize.pro_asset_sizes.medium
                        )
                        .shift().url
                    "
                    :alt="
                      getAltText(
                        data.partner_information.product_name,
                        data.partner_information.product_assets
                          .filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assetsSize.pro_asset_sizes.medium
                          )
                          .shift().url
                      )
                    "
                  />
                  <div class="partner-hover wd-promo">
                    <div
                      class="partner-hover-inner"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="16"
                        viewBox="0 0 10 16"
                        fill="none"
                      >
                        <path
                          d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </a>
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="data.partner_information.product_name"
                    class="cas-title custom-font-1 text-hover"
                    v-if="data.partner_information.review_link"
                    :href="
                      getRouteLink(
                        data.partner_information.review_link,
                        'review'
                      )
                    "
                    >{{ data.partner_information.product_name }}</a
                  >
                  <span class="cas-title custom-font-1" v-else>{{
                    data.partner_information.product_name
                  }}</span>
                </template>
                <template v-else>
                  <router-link
                    :title="data.partner_information.product_name"
                    class="cas-title custom-font-1 text-hover"
                    v-if="data.partner_information.review_link"
                    :to="
                      getRouteLink(
                        data.partner_information.review_link,
                        'review'
                      )
                    "
                    >{{ data.partner_information.product_name }}</router-link
                  >
                  <span class="cas-title custom-font-1" v-else>{{
                    data.partner_information.product_name
                  }}</span>
                </template>

                <div class="advent-bonus">
                  <template v-if="hideBonusLabel">
                    <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                  </template>
                  <template v-else>
                    <a
                      v-if="data.partner_information.go_link"
                      :title="data.partner_information.product_name"
                      :href="
                        getGoLink(
                          data.partner_information.go_link,
                          data.partner_information.slug
                        )
                      "
                      class="cas-link text-hover"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <span class="bonus">{{
                        $root.i18n.christmas_special_bonus
                      }}</span>
                      <span
                        class="bonus bonus-amt custom-font-1"
                        v-if="
                          data.partner_information.bonus_match &&
                          data.partner_information.exclusive_bonus_amount &&
                          data.partner_information.exclusive_bonus_match
                        "
                        >{{ data.partner_information.exclusive_bonus_match }}%
                        {{ $root.i18n.up_to }}
                        {{
                          data.partner_information.exclusive_bonus_amount
                            | currency(data.partner_information.bonus_currency)
                        }}</span
                      >
                      <span
                        class="bonus bonus-amt custom-font-1"
                        v-if="
                          data.partner_information.bonus_match &&
                          !data.partner_information.exclusive_bonus_amount &&
                          data.partner_information.bonus_amount
                        "
                        >{{ data.partner_information.bonus_match }}%
                        {{ $root.i18n.up_to }}
                        {{
                          data.partner_information.bonus_amount
                            | currency(data.partner_information.bonus_currency)
                        }}</span
                      >
                      <span
                        :class="{
                          'bonus bonus-amt custom-font-1': true,
                        }"
                        v-if="
                          data.partner_information.freespin ||
                          data.partner_information.freebie_name
                        "
                      >
                        <template
                          v-if="
                            (data.partner_information.exclusive_bonus_amount ||
                              data.partner_information.bonus_amount) &&
                            data.partner_information.bonus_match
                          "
                          >+</template
                        >
                        <template v-if="data.partner_information.freespin">
                          <template
                            v-if="
                              data.partner_information.show_freebie_currency ===
                              '1'
                            "
                            >{{
                              data.partner_information.freespin
                                | currency(
                                  data.partner_information.bonus_currency
                                )
                            }}</template
                          >
                          <template v-else>{{
                            data.partner_information.freespin
                          }}</template>
                          {{ data.partner_information.freebie_name }}
                        </template>
                        <template v-else>{{
                          data.partner_information.freebie_name
                        }}</template>
                      </span>
                    </a>
                  </template>
                </div>
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :class="{
                    'cta cta-play custom-btn hover-btn cas-link': true,
                    'text-white':
                      !$root.override_ctabtntxt_color &&
                      !getContrastYIQ($root.color_schema.primary_btn),
                    'text-gray':
                      !$root.override_ctabtntxt_color &&
                      getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                >
                  <span class="cta-text">
                    <img
                      :src="crownIcon"
                      alt="Crown"
                      v-if="index === 1"
                    />
                    {{ data.partner_information.cta_button_text }}</span
                  >
                  <span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `cardtpp`"
                    >{{ char }}</span
                  >
                </a>
                <div class="div-tt">
                  <span
                    class="tc-text cas-term"
                    v-if="
                      (data.partner_information.bonus_tc &&
                        data.partner_information.bonus_tc != '') ||
                      (data.partner_information.terms &&
                        data.partner_information.terms != '')
                    "
                    v-html="data.partner_information.bonus_tc"
                    :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                  ></span>
                  <span
                    class="card-stroke"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.terms &&
                      data.partner_information.bonus_tc != '' &&
                      data.partner_information.terms != ''
                    "
                    >|</span
                  >
                  <a
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    class="tc-text cas-term"
                    v-if="
                      data.partner_information.terms &&
                      data.partner_information.terms != ''
                    "
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.term_link,
                        data.partner_information.slug
                      )
                    "
                    target="_blank"
                    >{{ data.partner_information.terms }}</a
                  >
                </div>
              </div>
              <div
                class="overlay"
                v-if="
                  getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today')
                "
              ></div>
            </template>
            <template
              v-else-if="
                data.type === 'promotion' &&
                Object.keys(data.partner_information).length > 0 &&
                Object.keys(data.promotion_information).length > 0
              "
            >
              <div class="advent-card-bg">
                <template
                  v-if="
                    !(
                      getTimeStamp(data.Ymd, 'addate') <=
                      getTimeStamp('', 'today')
                    )
                  "
                >
                  <img
                    v-if="adventCalendarAttrs.card_coming_soon_image"
                    :src="adventCalendarAttrs.card_coming_soon_image"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
                <template v-else>
                  <img
                    v-if="adventCalendarAttrs.feast_card_background"
                    :src="adventCalendarAttrs.feast_card_background"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
              </div>
              <div
                :class="{
                  'advent-card-content': true,
                  'advent-promo-card': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <div class="offer-meta-bg"></div>
                <div class="offer-meta">
                  <div class="offer-meta-logo">
                    <a
                      v-if="data.partner_information.go_link"
                      :title="data.partner_information.product_name"
                      :href="
                        getGoLink(
                          data.partner_information.go_link,
                          data.partner_information.slug
                        )
                      "
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      target="_blank"
                      class="partner-logo pt-100 cas-link"
                    >
                      <img
                        v-if="
                          assetsSize &&
                          assetsSize.pro_asset_sizes &&
                          data.partner_information.product_assets &&
                          data.partner_information.product_assets.length > 0
                        "
                        :src="
                          data.partner_information.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.medium
                            )
                            .shift().url
                        "
                        :alt="
                          getAltText(
                            data.partner_information.product_name,
                            data.partner_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assetsSize.pro_asset_sizes.medium
                              )
                              .shift().url
                          )
                        "
                      />
                      <div class="partner-hover wd-promo">
                        <div
                          class="partner-hover-inner"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="16"
                            viewBox="0 0 10 16"
                            fill="none"
                          >
                            <path
                              d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="offer-meta-title">
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="data.partner_information.product_name"
                        class="partner-name custom-font-1 text-hover"
                        v-if="data.partner_information.review_link"
                        :href="
                          getRouteLink(
                            data.partner_information.review_link,
                            'review'
                          )
                        "
                        >{{ data.partner_information.product_name }}</a
                      >
                      <span class="partner-name custom-font-1" v-else>{{
                        data.partner_information.product_name
                      }}</span>
                    </template>
                    <template v-else>
                      <router-link
                        :title="data.partner_information.product_name"
                        class="partner-name custom-font-1 text-hover"
                        v-if="data.partner_information.review_link"
                        :to="
                          getRouteLink(
                            data.partner_information.review_link,
                            'review'
                          )
                        "
                        >{{
                          data.partner_information.product_name
                        }}</router-link
                      >
                      <span class="partner-name custom-font-1" v-else>{{
                        data.partner_information.product_name
                      }}</span>
                    </template>
                    <StarRating
                      :rating="
                        parseFloat(
                          (data.partner_information.rating / 2).toFixed(1)
                        )
                      "
                      :classParam="strCls"
                    />
                  </div>
                </div>
                <div class="offer-meta-bonus">
                  <div class="card-tags">
                    <span class="promotion-tag">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="5"
                        height="9"
                        viewBox="0 0 5 9"
                        fill="none"
                      >
                        <path
                          d="M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z"
                          fill="black"
                        ></path>
                      </svg>
                      {{ $root.i18n.promotion }}
                    </span>
                  </div>
                  <a
                    v-if="data.partner_information.go_link"
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      )
                    "
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    target="_blank"
                    class="partner-name custom-font-1 cas-link text-hover"
                  >
                    <span
                      class="bonus-text prob-text"
                      v-if="
                        data.promotion_information &&
                        data.promotion_information.post_excerpt.length < 100
                      "
                      >{{ data.promotion_information.post_excerpt }}</span
                    >
                    <span class="bonus-text prob-text" v-else>{{
                      data.promotion_information.post_excerpt.slice(0, 100) +
                      "..."
                    }}</span>
                  </a>
                </div>
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :class="{
                    'cta cta-play custom-btn hover-btn cas-link': true,
                    'text-white':
                      !$root.override_ctabtntxt_color &&
                      !getContrastYIQ($root.color_schema.primary_btn),
                    'text-gray':
                      !$root.override_ctabtntxt_color &&
                      getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                >
                  <span class="cta-text">
                    <img
                      :src="crownIcon"
                      alt="Crown"
                      v-if="index === 1"
                    />
                    {{ data.partner_information.cta_button_text }}</span
                  >
                  <span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `cardtpp`"
                    >{{ char }}</span
                  >
                </a>
                <!--<span class="timer-text prob-time">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                  >
                    <path
                      d="M13.1265 2.24486L12.4548 3.40718L14.7823 4.75061L15.454 3.58826C15.639 3.26561 15.5289 2.85623 15.2075 2.66983L14.0452 1.99809C13.7236 1.81188 13.313 1.92205 13.1265 2.24486Z"
                      fill="#FE4646"
                    ></path>
                    <path
                      d="M8.9999 3.02484C9.42474 3.02484 9.83974 3.06641 10.2499 3.125V2.03781L11.1093 2.03124V0.625C11.1093 0.279543 10.8297 0 10.4843 0H7.52209C7.17664 0 6.89709 0.279543 6.89709 0.625V2.03124L7.7499 2.03781V3.125C8.16007 3.06641 8.57507 3.02484 8.9999 3.02484Z"
                      fill="#FE4646"
                    ></path>
                    <path
                      d="M9 3.75C4.51268 3.75 0.875 7.38765 0.875 11.875C0.875 16.3624 4.51268 20 9 20C13.4873 20 17.125 16.3624 17.125 11.875C17.125 7.38765 13.4873 3.75 9 3.75ZM12.7969 15.6938L8.06248 12.4161V7.78889H9.42876V11.7003L13.5745 14.5705L12.7969 15.6938Z"
                      fill="#FE4646"
                    ></path>
                  </svg>
                  <span class="time-text">Verbleibende Zeit:</span>
                  <span class="text-bold">
                    <span class="fw-bold">16</span> Tage,
                    <span class="fw-bold">12</span> Stunden,
                    <span class="fw-bold">22</span> Minuten
                  </span>
                </span>-->
                <div
                  class="terms prob-term"
                  v-if="
                    (data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != '') ||
                    (data.partner_information.terms &&
                      data.partner_information.terms != '')
                  "
                >
                  <span
                    :class="{
                      'terms_tc cas-term term-text-font-color': true,
                    }"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != ''
                    "
                    v-html="data.partner_information.bonus_tc"
                    :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                  ></span>
                  <span
                    class="data.partner_information-stroke"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.terms &&
                      data.partner_information.bonus_tc != '' &&
                      data.partner_information.terms != ''
                    "
                    >|</span
                  >
                  <a
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    :class="{
                      'terms_tc cas-term term-text-font-color': true,
                    }"
                    v-if="
                      data.partner_information.terms &&
                      data.partner_information.terms != ''
                    "
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.term_link,
                        data.partner_information.slug
                      )
                    "
                    target="_blank"
                    >{{ data.partner_information.terms }}</a
                  >
                </div>
              </div>
              <div
                class="overlay"
                v-if="
                  getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today')
                "
              ></div>
            </template>
          </div>
        </div>
        <div class="advent-cards-wrapper">
          <div
            :class="{
              'advent-card advent-card-yellow': true,
              'advent-card-big current-no-active':
                getTimeStamp(data.Ymd, 'addate') === getTimeStamp('', 'today'),
              'advent-card-mobile':
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today'),
              'advent-promo-card':
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today') &&
                getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today', 2),
              'not-active':
                !getTimeStamp(data.Ymd, 'addate') <= getTimeStamp('', 'today'),
            }"
            v-for="(data, index) in adventFinalData"
            :key="index"
          >
            <template
              v-if="
                data.type === 'partner' &&
                Object.keys(data.partner_information).length > 0
              "
            >
              <div
                :class="{
                  'advent-card-bg': true,
                  'advent-promo-card-up-bg': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <template
                  v-if="
                    !(
                      getTimeStamp(data.Ymd, 'addate') <=
                      getTimeStamp('', 'today')
                    )
                  "
                >
                  <img
                    v-if="adventCalendarAttrs.card_coming_soon_image"
                    :src="adventCalendarAttrs.card_coming_soon_image"
                    alt="
                   Advent card bg image
                  "
                  />
                  <span class="ring-title custom-font-1">{{
                    Number(data.Ymd.slice(6, 8))
                  }}</span>
                </template>
                <template v-else>
                  <img
                    v-if="adventCalendarAttrs.feast_card_background"
                    :src="adventCalendarAttrs.feast_card_background"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
              </div>
              <div
                :class="{
                  'advent-card-content': true,
                  'advent-promo-card': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  class="cas-logo partner-logo pt-100 cas-link"
                >
                  <img
                    v-if="
                      assetsSize &&
                      assetsSize.pro_asset_sizes &&
                      data.partner_information.product_assets &&
                      data.partner_information.product_assets.length > 0
                    "
                    :src="
                      data.partner_information.product_assets.filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assetsSize.pro_asset_sizes.medium
                      ).length > 0
                        ? data.partner_information.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.medium
                            )
                            .shift().url
                        : $root.site_url + $root.asset_path + '/failure.png'
                    "
                    :alt="
                      getAltText(
                        data.partner_information.product_name,
                        data.partner_information.product_assets.filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assetsSize.pro_asset_sizes.medium
                        ).length > 0
                          ? data.partner_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assetsSize.pro_asset_sizes.medium
                              )
                              .shift().url
                          : $root.site_url + $root.asset_path + '/failure.png'
                      )
                    "
                  />
                  <div class="partner-hover wd-promo">
                    <div
                      class="partner-hover-inner"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="16"
                        viewBox="0 0 10 16"
                        fill="none"
                      >
                        <path
                          d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </a>
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="data.partner_information.product_name"
                    class="cas-title custom-font-1 text-hover"
                    v-if="data.partner_information.review_link"
                    :href="
                      getRouteLink(
                        data.partner_information.review_link,
                        'review'
                      )
                    "
                    >{{ data.partner_information.product_name }}</a
                  >
                  <span class="cas-title custom-font-1" v-else>{{
                    data.partner_information.product_name
                  }}</span>
                </template>
                <template v-else>
                  <router-link
                    :title="data.partner_information.product_name"
                    class="cas-title custom-font-1 text-hover"
                    v-if="data.partner_information.review_link"
                    :to="
                      getRouteLink(
                        data.partner_information.review_link,
                        'review'
                      )
                    "
                    >{{ data.partner_information.product_name }}</router-link
                  >
                  <span class="cas-title custom-font-1" v-else>{{
                    data.partner_information.product_name
                  }}</span>
                </template>
                <div class="advent-bonus">
                  <template v-if="hideBonusLabel">
                    <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                  </template>
                  <template v-else>
                    <a
                      v-if="data.partner_information.go_link"
                      :title="data.partner_information.product_name"
                      :href="
                        getGoLink(
                          data.partner_information.go_link,
                          data.partner_information.slug
                        )
                      "
                      class="cas-link text-hover"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <span class="bonus">{{
                        $root.i18n.christmas_special_bonus
                      }}</span>
                      <span
                        class="bonus bonus-amt custom-font-1"
                        v-if="
                          data.partner_information.bonus_match &&
                          data.partner_information.exclusive_bonus_amount &&
                          data.partner_information.exclusive_bonus_match
                        "
                        >{{ data.partner_information.exclusive_bonus_match }}%
                        {{ $root.i18n.up_to }}
                        {{
                          data.partner_information.exclusive_bonus_amount
                            | currency(data.partner_information.bonus_currency)
                        }}</span
                      >
                      <span
                        class="bonus bonus-amt custom-font-1"
                        v-if="
                          data.partner_information.bonus_match &&
                          !data.partner_information.exclusive_bonus_amount &&
                          data.partner_information.bonus_amount
                        "
                        >{{ data.partner_information.bonus_match }}%
                        {{ $root.i18n.up_to }}
                        {{
                          data.partner_information.bonus_amount
                            | currency(data.partner_information.bonus_currency)
                        }}</span
                      >
                      <span
                        :class="{
                          'bonus bonus-amt custom-font-1': true,
                        }"
                        v-if="
                          data.partner_information.freespin ||
                          data.partner_information.freebie_name
                        "
                      >
                        <template
                          v-if="
                            (data.partner_information.exclusive_bonus_amount ||
                              data.partner_information.bonus_amount) &&
                            data.partner_information.bonus_match
                          "
                          >+</template
                        >
                        <template v-if="data.partner_information.freespin">
                          <template
                            v-if="
                              data.partner_information.show_freebie_currency ===
                              '1'
                            "
                            >{{
                              data.partner_information.freespin
                                | currency(
                                  data.partner_information.bonus_currency
                                )
                            }}</template
                          >
                          <template v-else>{{
                            data.partner_information.freespin
                          }}</template>
                          {{ data.partner_information.freebie_name }}
                        </template>
                        <template v-else>{{
                          data.partner_information.freebie_name
                        }}</template>
                      </span>
                    </a>
                  </template>
                </div>
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :class="{
                    'cta cta-play custom-btn hover-btn cas-link': true,
                    'text-white':
                      !$root.override_ctabtntxt_color &&
                      !getContrastYIQ($root.color_schema.primary_btn),
                    'text-gray':
                      !$root.override_ctabtntxt_color &&
                      getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                >
                  <span class="cta-text">
                    <img
                      :src="crownIcon"
                      alt="Crown"
                      v-if="index === 1"
                    />
                    {{ data.partner_information.cta_button_text }}</span
                  >
                  <span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `cardtpp`"
                    >{{ char }}</span
                  >
                </a>
                <div class="div-tt">
                  <span
                    class="tc-text cas-term"
                    v-if="
                      (data.partner_information.bonus_tc &&
                        data.partner_information.bonus_tc != '') ||
                      (data.partner_information.terms &&
                        data.partner_information.terms != '')
                    "
                    v-html="data.partner_information.bonus_tc"
                    :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                  ></span>
                  <span
                    class="card-stroke"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.terms &&
                      data.partner_information.bonus_tc != '' &&
                      data.partner_information.terms != ''
                    "
                    >|</span
                  >
                  <a
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    class="tc-text cas-term"
                    v-if="
                      data.partner_information.terms &&
                      data.partner_information.terms != ''
                    "
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.term_link,
                        data.partner_information.slug
                      )
                    "
                    target="_blank"
                    >{{ data.partner_information.terms }}</a
                  >
                </div>
              </div>
              <div
                class="overlay"
                v-if="
                  getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today')
                "
              ></div>
            </template>
            <template
              v-else-if="
                data.type === 'promotion' &&
                Object.keys(data.partner_information).length > 0 &&
                Object.keys(data.promotion_information).length > 0
              "
            >
              <div class="advent-card-bg">
                <template
                  v-if="
                    !(
                      getTimeStamp(data.Ymd, 'addate') <=
                      getTimeStamp('', 'today')
                    )
                  "
                >
                  <img
                    v-if="adventCalendarAttrs.card_coming_soon_image"
                    :src="adventCalendarAttrs.card_coming_soon_image"
                    alt="
                   Advent card bg image
                  "
                  />
                  <span class="ring-title custom-font-1">{{
                    Number(data.Ymd.slice(6, 8))
                  }}</span>
                </template>
                <template v-else>
                  <img
                    v-if="adventCalendarAttrs.feast_card_background"
                    :src="adventCalendarAttrs.feast_card_background"
                    alt="
                   Advent card bg image
                  "
                  />
                </template>
              </div>
              <div
                :class="{
                  'advent-card-content': true,
                  'advent-promo-card': !(
                    getTimeStamp(data.Ymd, 'addate') <=
                    getTimeStamp('', 'today')
                  ),
                }"
              >
                <div class="offer-meta-bg"></div>
                <div class="offer-meta">
                  <div class="offer-meta-logo">
                    <a
                      v-if="data.partner_information.go_link"
                      :title="data.partner_information.product_name"
                      :href="
                        getGoLink(
                          data.partner_information.go_link,
                          data.partner_information.slug
                        )
                      "
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      target="_blank"
                      class="partner-logo pt-100 cas-link"
                    >
                      <img
                        v-if="
                          assetsSize &&
                          assetsSize.pro_asset_sizes &&
                          data.partner_information.product_assets &&
                          data.partner_information.product_assets.length > 0
                        "
                        :src="
                          data.partner_information.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assetsSize.pro_asset_sizes.medium
                          ).length > 0
                            ? data.partner_information.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assetsSize.pro_asset_sizes.medium
                                )
                                .shift().url
                            : $root.site_url + $root.asset_path + '/failure.png'
                        "
                        :alt="
                          getAltText(
                            data.partner_information.product_name,
                            data.partner_information.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.medium
                            ).length > 0
                              ? data.partner_information.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assetsSize.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                          )
                        "
                      />
                      <div class="partner-hover wd-promo">
                        <div
                          class="partner-hover-inner"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="16"
                            viewBox="0 0 10 16"
                            fill="none"
                          >
                            <path
                              d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="offer-meta-title">
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="data.partner_information.product_name"
                        class="partner-name custom-font-1 text-hover"
                        v-if="data.partner_information.review_link"
                        :href="
                          getRouteLink(
                            data.partner_information.review_link,
                            'review'
                          )
                        "
                        >{{ data.partner_information.product_name }}</a
                      >
                      <span class="partner-name custom-font-1" v-else>{{
                        data.partner_information.product_name
                      }}</span>
                    </template>
                    <template v-else>
                      <router-link
                        :title="data.partner_information.product_name"
                        class="partner-name custom-font-1 text-hover"
                        v-if="data.partner_information.review_link"
                        :to="
                          getRouteLink(
                            data.partner_information.review_link,
                            'review'
                          )
                        "
                        >{{
                          data.partner_information.product_name
                        }}</router-link
                      >
                      <span class="partner-name custom-font-1" v-else>{{
                        data.partner_information.product_name
                      }}</span>
                    </template>
                    <StarRating
                      :rating="
                        parseFloat(
                          (data.partner_information.rating / 2).toFixed(1)
                        )
                      "
                      :classParam="strCls"
                    />
                  </div>
                </div>
                <div class="offer-meta-bonus">
                  <div class="card-tags">
                    <span class="promotion-tag">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="5"
                        height="9"
                        viewBox="0 0 5 9"
                        fill="none"
                      >
                        <path
                          d="M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z"
                          fill="black"
                        ></path>
                      </svg>
                      {{ $root.i18n.promotion }}
                    </span>
                  </div>
                  <a
                    v-if="data.partner_information.go_link"
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      )
                    "
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    target="_blank"
                    class="partner-name custom-font-1 cas-link text-hover"
                  >
                    <span
                      class="bonus-text prob-text"
                      v-if="
                        data.promotion_information &&
                        data.promotion_information.post_excerpt.length < 100
                      "
                      >{{ data.promotion_information.post_excerpt }}</span
                    >
                    <span class="bonus-text prob-text" v-else>{{
                      data.promotion_information.post_excerpt.slice(0, 100) +
                      "..."
                    }}</span>
                  </a>
                </div>
                <a
                  v-if="data.partner_information.go_link"
                  :title="data.partner_information.product_name"
                  :href="
                    getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    )
                  "
                  :class="{
                    'cta cta-play custom-btn hover-btn cas-link': true,
                    'text-white':
                      !$root.override_ctabtntxt_color &&
                      !getContrastYIQ($root.color_schema.primary_btn),
                    'text-gray':
                      !$root.override_ctabtntxt_color &&
                      getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                >
                  <span class="cta-text">
                    <img
                      :src="crownIcon"
                      alt="Crown"
                      v-if="index === 1"
                    />
                    {{ data.partner_information.cta_button_text }}</span
                  >
                  <span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `cardtpp`"
                    >{{ char }}</span
                  >
                </a>
                <!--<span class="timer-text prob-time">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                  >
                    <path
                      d="M13.1265 2.24486L12.4548 3.40718L14.7823 4.75061L15.454 3.58826C15.639 3.26561 15.5289 2.85623 15.2075 2.66983L14.0452 1.99809C13.7236 1.81188 13.313 1.92205 13.1265 2.24486Z"
                      fill="#FE4646"
                    ></path>
                    <path
                      d="M8.9999 3.02484C9.42474 3.02484 9.83974 3.06641 10.2499 3.125V2.03781L11.1093 2.03124V0.625C11.1093 0.279543 10.8297 0 10.4843 0H7.52209C7.17664 0 6.89709 0.279543 6.89709 0.625V2.03124L7.7499 2.03781V3.125C8.16007 3.06641 8.57507 3.02484 8.9999 3.02484Z"
                      fill="#FE4646"
                    ></path>
                    <path
                      d="M9 3.75C4.51268 3.75 0.875 7.38765 0.875 11.875C0.875 16.3624 4.51268 20 9 20C13.4873 20 17.125 16.3624 17.125 11.875C17.125 7.38765 13.4873 3.75 9 3.75ZM12.7969 15.6938L8.06248 12.4161V7.78889H9.42876V11.7003L13.5745 14.5705L12.7969 15.6938Z"
                      fill="#FE4646"
                    ></path>
                  </svg>
                  <span class="time-text">Verbleibende Zeit:</span>
                  <span class="text-bold">
                    <span class="fw-bold">16</span> Tage,
                    <span class="fw-bold">12</span> Stunden,
                    <span class="fw-bold">22</span> Minuten
                  </span>
                </span>-->
                <div
                  class="terms prob-term"
                  v-if="
                    (data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != '') ||
                    (data.partner_information.terms &&
                      data.partner_information.terms != '')
                  "
                >
                  <span
                    :class="{
                      'terms_tc cas-term term-text-font-color': true,
                    }"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != ''
                    "
                    v-html="data.partner_information.bonus_tc"
                    :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                  ></span>
                  <span
                    class="data.partner_information-stroke"
                    v-if="
                      data.partner_information.bonus_tc &&
                      data.partner_information.terms &&
                      data.partner_information.bonus_tc != '' &&
                      data.partner_information.terms != ''
                    "
                    >|</span
                  >
                  <a
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    :class="{
                      'terms_tc cas-term term-text-font-color': true,
                    }"
                    v-if="
                      data.partner_information.terms &&
                      data.partner_information.terms != ''
                    "
                    :title="data.partner_information.product_name"
                    :href="
                      getGoLink(
                        data.partner_information.term_link,
                        data.partner_information.slug
                      )
                    "
                    target="_blank"
                    >{{ data.partner_information.terms }}</a
                  >
                </div>
              </div>
              <div
                class="overlay"
                v-if="
                  getTimeStamp(data.Ymd, 'addate') < getTimeStamp('', 'today')
                "
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { pSBC, getContrastYIQ } from "@/misc/misc-function";
import currency from "@/misc/currency";
import Breadcrumb from "@/components/layouts/Breadcrumb";
import StarRating from "@/components/ui/StarRating";
export default {
  name: "AdventCalendar",
  props: [
    "adventCalendarData",
    "adventCalendarAttrs",
    "adventCalendarBreadcrumbs",
    "activeBreadcrumb",
    "assetsSize",
  ],
  data() {
    return {
      hideBonusLabel: false,
      strCls: "star-cls",
      adventFinalData: {},
      currentData: {},
      crownIcon: '',
    };
  },
  filters: {
    currency,
  },
  components: {
    Breadcrumb,
    StarRating,
  },
  methods: {
    pSBC,
    getContrastYIQ,
    updateBonusHeight: function () {
      let heightArr = [];
      document.querySelectorAll(".advent-bonus").forEach((ele) => {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".advent-bonus").forEach((ele) => {
        ele.style.height = `${Math.max(...heightArr)}px`;
      });
    },
    getTimeStamp: function (time, text, value = null) {
      let timestamp = "";

      if (text === "today") {
        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        let day =
          value === null
            ? new Date().getDate()
            : new Date().getDate() - Number(value);

        if (day <= 9) day = `0${day}`;

        timestamp = new Date(`${year}-${month}-${day}`).getTime();
        return timestamp;
      }

      const year = time.slice(0, 4);
      const month = time.slice(4, 6);
      const day = time.slice(6, 8);

      timestamp = new Date(`${year}-${month}-${day}`).getTime();
      return timestamp;
    },
  },
  created() {
    const assetPath = `${global.wpvue_script_data_params.site_url}/wp-content/themes/wpvue/src/assets/images`
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted() {
    let _filterData = [];
    Object.keys(this.adventCalendarData.data).forEach((ele) => {
      if (
        (this.adventCalendarData.data[ele].type === "promotion" &&
          Object.keys(this.adventCalendarData.data[ele].partner_information)
            .length > 0 &&
          Object.keys(this.adventCalendarData.data[ele].promotion_information)
            .length > 0) ||
        (this.adventCalendarData.data[ele].type === "partner" &&
          Object.keys(this.adventCalendarData.data[ele].partner_information)
            .length > 0)
      )
        return _filterData.push(this.adventCalendarData.data[ele]);
    });
    this.adventFinalData = [..._filterData];

    let _filterCurrentData = _filterData.filter(
      (ele) => Number(ele.Ymd.slice(6, 8)) === new Date().getDate()
    );
    this.currentData = [..._filterCurrentData];

    this.$nextTick(() => {
      this.updateBonusHeight();
    });
    window.addEventListener("resize", () => {
      this.updateBonusHeight();
    });
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", () => {
      this.updateBonusHeight();
    });
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.advent-calendar-section {
  //background: #29355a url("../images/advent-bg.svg") no-repeat left bottom;
  background-size: 100% auto;
  padding: 22px 0 22px;
  @media (min-width: @sizes[medium]) {
    padding: 13px 0 13px;
  }
  @media (min-width: @sizes[md-large]) {
    padding: 49px 0 49px;
  }
  .container {
    padding: 0 15px;
  }
}
.advent-header {
  margin-bottom: 23px;
  @media (min-width: @sizes[medium]) {
    margin-bottom: 27px;
  }
  @media (min-width: @sizes[md-large]) {
    margin-bottom: 49px;
  }
  .span-h1 {
    text-align: center;
    font-family: cinzel;
    color: #ebe2d0;
    margin-bottom: 0;
  }
  span {
    text-align: center;
  }
  p {
    text-align: center;
    color: @white;
    margin-bottom: 0;
  }
}
.advent-cards-wrapper {
  .display-flex();
  .flex-wrap(wrap);
  margin: 0px;
  padding: 0px;
  .justify-content-flex-start();
  width: 308px;
  margin: 0 auto;
  @media (min-width: @sizes[small]) {
    width: 460px;
  }
  @media (min-width: @sizes[medium]) {
    padding: 0 32px;
    width: 755px;
  }
  @media (min-width: @sizes[large]) {
    padding: 0;
    width: 890px;
  }
  @media (min-width: @sizes[md-large]) {
    .justify-content-flex-start();
    width: 1184px;
  }
  @media (min-width: @sizes[extra-large]) {
    margin: 0 -10px;
    width: 1240px;
  }
  // &:after {
  //   content: "";
  //   width: 152px;
  //   @media (min-width: 622px) {
  //     width: 456px;
  //   }
  //   @media (min-width: @sizes[medium]) {
  //     width: 170px;
  //   }
  // }
}

.advent-cards-wrapper-outer {
  display: none;
  @media (max-width: @sizes[medium]) {
    .display-flex();
    .flex-wrap(wrap);
    margin: 0px;
    padding: 0px;
    .justify-content-flex-start();
    @media (min-width: @sizes[medium]) {
      padding: 0 32px;
    }
    @media (min-width: @sizes[large]) {
      padding: 0;
    }
    @media (min-width: @sizes[md-large]) {
      .justify-content-flex-start();
    }
    @media (min-width: @sizes[extra-large]) {
      margin: 0 -10px;
    }
    // &:after {
    //   content: "";
    //   width: 152px;
    //   @media (min-width: 622px) {
    //     width: 456px;
    //   }
    //   @media (min-width: @sizes[medium]) {
    //     width: 170px;
    //   }
    // }
  }
}
.advent-card {
  width: 140px;
  height: 140px;
  border: 3px solid #f8efd3;
  filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05));
  .border-radius(10px);
  position: relative;
  //background: url("../images/red-square.svg") no-repeat 0 0;
  background-size: cover;
  margin: 0 6px 12px;
  overflow: hidden;
  @media (min-width: @sizes[medium]) {
    margin: 0 8px 14px;
    width: 156px;
    height: 156px;
  }
  @media (min-width: @sizes[large]) {
    width: 282px;
    height: 282px;
    margin: 0 7px 14px;
  }
  @media (min-width: @sizes[extra-large]) {
    margin: 0 10px 20px;
    width: 290px;
    height: 290px;
  }
  .ring {
    //background: url("../images/ring-leaf.svg") no-repeat 0 0;
    background-size: cover;
    width: 101px;
    height: 95px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .display-flex();
    .align-items(center);
    .justify-content-center();
    @media (min-width: @sizes[medium]) {
      width: 120px;
      height: 113px;
    }
    @media (min-width: @sizes[large]) {
      width: 223px;
      height: 210px;
    }
    span {
      font-family: var(--default-regular);
      font-weight: 800;
      font-size: 48px;
      line-height: 60px;
      text-align: center;
      color: @white;
      @media (min-width: @sizes[large]) {
        font-size: 96px;
        line-height: 120px;
      }
    }
  }
  &-yellow {
    //background: #ffdf39;
    background: #fff9e8;
    border: 2px solid #ebe2d0;
    .advent-card-bg {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .advent-card-content {
      padding: 15px 10px 5px;
      text-align: center;
      @media (min-width: @sizes[extra-small]) {
        padding: 17px 10px 5px;
      }
      .ribbon {
        position: absolute;
        left: 0;
        top: 0;
        max-width: 154px;
        @media (min-width: @sizes[small]) {
          max-width: 250px;
        }
        @media (min-width: @sizes[medium]) {
          max-width: 307px;
        }
        @media (min-width: @sizes[large]) {
          max-width: 154px;
        }
      }
      .cas-logo {
        display: block !important;
        margin: 0 auto 5px;
        width: 74px;
        height: 74px;
        .border-radius(5px);
        border: 1px solid #decd89;
        img {
          .border-radius(5px);
        }
      }
      .cas-title {
        display: inline-block;
        font-weight: bold;
        font-size: 16px;
        line-height: 160%;
        color: #decd89;
        @media (min-width: @sizes[extra-small]) {
          font-size: 16px;
          line-height: 160%;
        }
      }
      .bonus {
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: @white;
        display: block;
      }
      .bonus-amt {
        font-weight: bold;
        font-size: 24px;
        line-height: 23px;
        color: @white;
        margin-bottom: 8px;
        display: inline-block;
        max-width: 255px;
        @media (min-width: @sizes[extra-small]) {
          margin-bottom: 10px;
        }
        @media (min-width: @sizes[large]) {
          max-width: none;
        }
      }
      .div-tt {
        @media (min-width: @sizes[large]) {
          line-height: 13px;
        }
      }
      .tc-text {
        font-weight: normal;
        font-size: 12px;
        line-height: 160%;
        color: @white;
        margin: 0;
        @media (min-width: @sizes[large]) {
          line-height: 12px;
        }
        @media (min-width: @sizes[extra-large]) {
          line-height: 12px;
        }
      }
      .cta-play {
        display: block;
        width: 100%;
        background: #fe4646;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        .border-radius(5px);
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: @white;
        padding: 8px;
        margin: 0 auto 10px;
        max-width: 525px;
        &:hover,
        &:focus {
          opacity: 0.7;
        }
        @media (min-width: @sizes[large]) {
          max-width: none;
          margin: 0 auto 2px;
        }
        @media (min-width: @sizes[extra-large]) {
          margin: 0 auto 10px;
        }
      }
      .offer-meta-bg {
        position: absolute;
        z-index: -1;
        left: -3px;
        top: -3px;
        right: -3px;
        bottom: -3px;
        .border-radius(10px);
        overflow: hidden;
        &:before {
          content: "";
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.6)
          );
          z-index: 0;
        }
      }
      .offer-meta {
        .display-flex();
        &-logo {
          height: 50px;
          width: 50px;
          min-width: 50px;
          .border-radius(12px);
          overflow: hidden;
          .partner-logo {
            display: block;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              .border-radius(5px);
            }
          }
        }
        &-title {
          font-size: 14px;
          line-height: 150%;
          font-weight: 700;
          margin-left: 8px;
          color: @white;
          text-align: left;
          .partner-name {
            color: @white;
          }
        }
      }
      .offer-meta-bonus {
        width: 100%;
        margin: 10px auto;
        padding: 10px 12px;
        .border-radius(12px);
        border: 2px dashed @white;
        .card-tags {
          .display-flex();
          .justify-content-center();
          margin-bottom: 10px;
          .promotion-tag {
            background: #ffd039;
            text-align: center;
            font-weight: 600;
            .border-radius(100px);
            padding: 6px;
            font-size: 12px;
            line-height: 8px;
            margin: 0 3px;
          }
        }
        .bonus-text {
          font-size: 16px;
          line-height: 18px;
          width: 100%;
          margin: 0 auto;
          display: block;
          text-align: center;
          color: @white;
        }
        .partner-name {
          color: @white!important;
          span.bonus-text {
            color: @white;
          }
        }
      }
      .timer-text {
        margin: 10px auto;
        display: block;
        text-align: center;
        font-size: 14px;
        line-height: 15px;
        color: #fe4646;
        white-space: normal;
        svg {
          vertical-align: text-bottom;
          margin-right: 6px;
        }
      }
      .terms {
        padding: 5px 11px;
        background: rgba(239, 241, 245, 0.1);
        margin: 0;
        text-align: center;
        .display-flex();
        .justify-content-center();
        .align-items(center);
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto;
        span {
          font-size: 12px;
          line-height: 160%;
          color: @white;
        }
      }
    }
  }
  .overlay {
    position: absolute;
    content: "";
    left: -3px;
    top: -3px;
    right: -3px;
    bottom: -3px;
    display: block;
    background: rgba(41, 53, 90, 0.8);
    .border-radius(10px);
  }
  &-big {
    width: 290px;
    height: 290px;
    margin: 0 auto 14px;
    @media (min-width: @sizes[small]) {
      width: 100%;
      height: 290px;
      margin: 0 8px 14px;
    }
    @media (min-width: @sizes[large]) {
      width: 282px;
      height: 282px;
      margin: 0 7px 14px;
    }
    @media (min-width: @sizes[extra-large]) {
      width: 290px;
      height: 290px;
      margin: 0 7px 14px;
    }
  }
  &-mobile {
    display: none;
    @media (min-width: @sizes[large]) {
      display: block;
    }
  }
}

.advent-bonus {
  display: flex;
  justify-content: center;
  align-items: center;
}

.advent-promo-card {
  display: none;
}

.advent-promo-card-up-bg {
  img {
    z-index: 1;
  }
}

.span-h1 {
  color: @white !important;
}

.current-no-active {
  display: none;
  @media (min-width: 769px) {
    display: block;
  }
}

.ring-title {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 48px;
  line-height: 60px;
  font-weight: 800;
  color: #424f5a;
  font-family: "DM Serif Display";
  transform: translate(-50%, -50%);
  @media (min-width: @sizes[large]) {
    font-size: 173px;
    line-height: 120px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/AdventCalendar.vue